import {ChannelService} from '../../services/Channel';
import {Channel, ChannelAPIResponse, Attachment} from 'stream-chat';
import {SET_CHANNEL, SET_CHANNELS_SEARCH} from '../actionTypes';
import {setLoading} from './global';

export const setChannelSuccess = (
  payload: {
    currentChannel?: Channel;
    currentWatchChannel?: ChannelAPIResponse;
  } = {},
) => ({
  type: SET_CHANNEL,
  payload,
});

export const setChannelSearchSuccess = (
  payload: {channelSearch?: Channel[]} = {},
) => ({
  type: SET_CHANNELS_SEARCH,
  payload,
});

export const getCurrentChannel = (): any => {
  return (dispatch: (action: any) => void, getState: any) => {
    return getState().channel.currentChannel;
  };
};

export const selectChat = ({
  id,
  callback,
  loading = true,
}: {
  id: string;
  callback?: () => void;
  loading?: boolean;
}) => {
  return (dispatch: (action: any) => void) => {
    if (loading) dispatch(setLoading({value: true}));
    ChannelService.getChannelByID({id})
      .then(channel => {
        ChannelService.watchChannel({channel})
          .then(currentWatchChannel => {
            dispatch(
              setChannelSuccess({currentChannel: channel, currentWatchChannel}),
            );
            if (callback) callback();
          })
          .catch(err => {
            //Add alert
            console.log(err);
          });
      })
      .catch(err => {
        //Add alert
        console.log(err);
      })
      .finally(() => {
        if (loading) dispatch(setLoading({value: false}));
      });
  };
};

export const selectOrCreateChat = ({
  name = '',
  members,
  callback,
}: {
  name?: string;
  members: string[];
  callback?: () => void;
}) => {
  return (dispatch: (action: any) => void) => {
    const channel = ChannelService.createChannel({name, members});
    ChannelService.watchChannel({channel})
      .then(currentWatchChannel => {
        dispatch(
          setChannelSuccess({currentChannel: channel, currentWatchChannel}),
        );
        if (callback) callback();
      })
      .catch(err => {
        //Add alert
        console.log(err);
      });
  };
};

export const setChannelSearch = (field: string, callback: () => void) => {
  return (dispatch: (action: any) => void) => {
    ChannelService.getChannels({members: [field]})
      .then(channels => {
        dispatch(setChannelSearchSuccess({channelSearch: [...channels]}));
      })
      .catch(err => {
        //Add alert
        console.log(err);
      })
      .finally(() => {
        callback();
      });
  };
};

export const hideChannel = (channel: Channel, callback?: () => void) => {
  return (dispatch: (action: any) => void) => {
    ChannelService.hideChannel({channel})
      .then(() => {
        if (callback) callback();
      })
      .catch(err => {
        //Add alert
        console.log(err);
      });
  };
};

export const archiveChannel = (channel: Channel, callback?: () => void) => {
  return (dispatch: (action: any) => void) => {
    ChannelService.archiveChannel({channel})
      .then(() => {
        if (callback) callback();
      })
      .catch(err => {
        //Add alert
        console.log(err);
      });
  };
};

export const sendMessage = (
  channel: Channel,
  text: string,
  attachments: Attachment[] = [],
  callback?: () => void,
  reply?: string,
) => {
  return (dispatch: (action: any) => void) => {
    const params: {[key: string]: any} = {
      channel,
      text,
      attachments,
    };

    if (reply) {
      params.quoted_message_id = reply;
    }
    ChannelService.sendMessage(params as any)
      .then(() => {
        if (callback) callback();
      })
      .catch(err => {
        //Add alert
        console.log(err);
      });
  };
};
